<template>
    <CList @FiltrarC="Lista" :pConfigList="ConfigList" :pFiltro="Filtro" :segurity="segurity">
        <template slot="Filtros">

        </template>
        <template slot="header">
            <th :class="StyleTh+' text-center'">#</th>
            <th :class="StyleTh">Responsable</th>
            <th :class="StyleTh">Fecha</th>
            <th :class="StyleTh">Descripcion</th>
        </template>
        <template slot="body">
            <tr v-for="(lista,index) in ListaArrayRows" :key="index">
                <td class="text-center"><p :class="StyleTd">{{(index+1)}}</p></td>
                <td><h6 :class="StylePr">{{lista.responsable.NombreCompleto}}</h6></td>
                <td><p :class="StyleTd">{{$getCleanDate(lista.created_at,true)}}</p></td>
                <td><p :class="StyleTd">{{lista.Descripcion}}</p></td>
            </tr>
        </template>
    </CList>
</template>

<script>
import Configs from '@/helpers/VarConfig.js';
const EmitEjecuta = 'seccionBitacora';

export default {
    name: 'ListaBitacora',
    props: ['objEnviado'],
    data() {
        return {
            ConfigList:{
                Title: 'Bitácora',
                IsModal: false,
                ShowLoader: true,
                ShowFiltros: true,
                ShowSearch:false,
                BtnNewShow:false,
                EmitSeccion: EmitEjecuta,
                BtnReturnShow: true,
                TitleFirst: 'Prospectos',
            },
            Filtro:{
                Nombre: '',
                Pagina: 1,
                Entrada: 25,
                TotalItem: 0,
                Placeholder: 'Buscar..',
                IdCotizacion:'',
                IdUsuario:''
            },
            segurity: {},
            obj: {},
            ListaArrayRows: [],               
            ListaHeader: [],
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd,
            Cotizaciones:[]
        }
    },
    methods: {
        async Lista(){
            this.ConfigList.ShowLoader = true;
            await this.$http.get('bitacora',{
                params:{
                    Pag: this.Filtro.Pagina,
                    Entrada: this.Filtro.Entrada,
                    IdCliente: this.objEnviado.IdCliente,
                    IdCotizacion:this.Filtro.IdCotizacion,
                    IdUsuario:this.Filtro.IdUsuario
                }
            }).then((res)=>{
                this.Filtro.Pagina      = res.data.data.current_page;
                this.Filtro.TotalItem   = res.data.data.total;
                this.ListaArrayRows=res.data.data.data;
                this.segurity           = res.data.segurity;
            }).finally(()=>{
                this.ConfigList.ShowLoader = false;
            })
        },
        Regresar() {
            this.$router.push({name:'prospectos',params:{}});
        },
    },
    created() {
        if(this.objEnviado!=undefined){
            sessionStorage.setItem('objCliente',JSON.stringify(this.objEnviado));
        }

        this.ObjCliente = JSON.parse(sessionStorage.getItem('objCliente'));

        this.bus.$off('List_'+EmitEjecuta);
        this.bus.$off('EmitReturn');
    },
    mounted() {
        this.Lista();
        this.bus.$on('List_'+EmitEjecuta,()=>
        {
            this.Lista();
        });

        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });
    },
}
</script>

<style>

</style>